/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TagValueDisplayType {
  Date = 'Date',
  String = 'String',
  Number = 'Number',
  NumberDecimal = 'NumberDecimal',
  Currency = 'Currency',
  UserFullName = 'UserFullName',
  DirectoryPath = 'DirectoryPath',
  FileName = 'FileName',
  SizeInBytes = 'SizeInBytes',
  Selection = 'Selection',
  DocumentType = 'DocumentType',
  Stamp = 'Stamp',
  Url = 'Url'
}
